<template>
  <div>
    <div class="header">
      <div class="text" style="justify-content: space-between;">
        <div>
          <span>运营管理 / 卡密管理 / </span>
          <span v-if="$route.query.type == 'add'">新增卡密</span>
          <span v-if="$route.query.type == 'edite'">编辑卡密</span>
          <span v-if="$route.query.type == 'view'">查看卡密</span>
        </div>
        <el-button type="primary" size="small" v-if="pageStatus == 'edite'"  @click="backPage()">返回</el-button>
      </div> 
    </div>
    <div class="content">
      <el-form ref="basicForm" inline :model="baseForm" label-width="140px" :rules="basicRules" size="medium">
        <el-form-item label="合作机构" prop="cardChannelId">
          <channelHospital ref='channelHospital' v-on:getChooseHospitalId='getHospitalId'
            :hospital='baseForm.cardChannelId' :hospitalState='pageStatus =="add" ? "1": ""' :hospitalDisabled='pageStatus =="add" ? "0":""' :disabled='pageStatus =="view" || pageStatus =="edite"' />
        </el-form-item>
        <el-form-item label="渠道类型：">
          <el-select disabled v-model="baseForm.channelType" placeholder="请选择渠道类型" filterable>
            <el-option v-for="(item,index) in channelTypeList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <span></span>
        </el-form-item>
        <el-form-item label="合作项目：" prop="coopItem">
          <el-input :disabled='pageStatus =="view"' clearable placeholder="例:安徽惠民保2023附加合作 (≤25字)"
            v-model.trim="baseForm.coopItem" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item label="合作期限：" prop="coopEndDate">
          <el-date-picker class="self-date"
            :disabled='((baseForm.cardCashState != 1 && pageStatus =="edite") || pageStatus =="view")?true:false'
            v-model="baseForm.coopStartDate" :picker-options="pickerOptions"   value-format="yyyy-MM-dd" type="date" placeholder="开始日期">
          </el-date-picker>
          <span class="separator">-</span>
          <el-date-picker class="self-date" :disabled='pageStatus =="view"'   value-format="yyyy-MM-dd" v-model="baseForm.coopEndDate"
            :picker-options="pickerOptions" type="date" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分账模式：" prop="splitAccountModel">
          <el-select v-model="baseForm.splitAccountModel" placeholder="请选择分账模式" @change='changeSelectModel'
            :disabled='pageStatus =="view"'>
            <el-option v-for="(item,index) in splitAccountModelOption" :key="index" :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
          <span class="el-form-item__error" v-if="pageStatus =='edite' && changeModeFlag">编辑后，历史数据中的分账类型不会随之更新</span>
        </el-form-item>
        <el-form-item label="兑换卡服务名称：" prop="cardName">
          <el-input placeholder="例:xx保险专享福利 (≤25字)" clearable :disabled='pageStatus =="view"'
            v-model.trim="baseForm.cardName" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item label="卡密兑换时限：" prop="cashEndDate">
          <el-date-picker class="self-date"
            :disabled='((baseForm.cardCashState != 1 && pageStatus =="edite") || pageStatus =="view")?true:false'
            v-model="baseForm.cashStartDate" :picker-options="pickerOptions"   value-format="yyyy-MM-dd" type="date" placeholder="开始日期">
          </el-date-picker>
          <span class="separator">-</span>
          <el-date-picker class="self-date" :disabled='pageStatus =="view"' v-model="baseForm.cashEndDate"
            :picker-options="pickerOptions"   value-format="yyyy-MM-dd" type="date" placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="卡密数量限额：" prop="cardNum">
          <el-input placeholder="请输入卡密数量限额" clearable @input="checkNum" :disabled='pageStatus =="view"' min='0'
            v-model.number="baseForm.cardNum" maxlength="6">
            <template slot="append">
              <span style="cursor:pointer">张</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="兑换次数：" prop="cashNum">
          <el-select disabled v-model="baseForm.cashNum" placeholder="请选择兑换次数" filterable>
            <el-option v-for="(item,index) in numberOption" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可兑换服务类目：" prop="cashServiceType">
          <el-select disabled v-model="baseForm.cashServiceType" placeholder="请选择服务类目" filterable>
            <el-option v-for="(item,index) in serveType" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务有效时限：" prop="serviceEffectiveLimit" class="serviceTime">
          <span class="title">兑换领取后</span>
          <el-input placeholder="请输入服务有效时限" clearable @input='inputLimit' :disabled='pageStatus =="view"'
            v-model.number="baseForm.serviceEffectiveLimit" maxlength="3">
            <template slot="append">
              <span>天</span>
            </template>
          </el-input>
          <span class="upTips" v-if="pageStatus =='edite' && changeLimtFlag">编辑后，已领取服务的有效期将不会随之更新</span>
        </el-form-item>
        <el-form-item label="可兑换资费类型：" prop="cashFeeType">
          <el-select disabled v-model="baseForm.cashFeeType" placeholder="请选择资费类型" filterable>
            <el-option v-for="(item,index) in expensesOption" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换权益：" prop="cashRights">
          <el-select disabled v-model="baseForm.cashRights" placeholder="请选择兑换权益" filterable>
            <el-option v-for="item in equityType" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道码：" prop="cardChannelCodePrefix">
          <div :class="pageStatus == 'add'?'channel-code':''">
            <el-input placeholder="请输入4位字母" clearable :disabled='pageStatus =="view"|| pageStatus =="edite"'
              v-model.trim="baseForm.cardChannelCodePrefix" @input='checkKey' maxlength="4">
            </el-input>
            <template v-if="pageStatus == 'add'">
              <i class="el-icon-plus"></i>
              <span>数字（自动生成）</span>
            </template>
          </div>
        </el-form-item>
        <div v-if="pageStatus!='view'" class="bottom-btn" style="text-align:center">
          <el-button @click="resetBasicForm()">重置</el-button>
          <el-button type="primary" @click="saveBasicForm()">保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template> 
<script>
import {
  cardDetails,
  addCard,
  editeCard,
  getChannelType
} from "@/api/cardPwd.js";
import local from "@/utils/local.js"; 
export default {
  components: {
    channelHospital: () =>
      import("@/components/selectHospital/channelIndex.vue")
  },
  props: {},
  data() {
    return {
      changeLimtFlag: false,
      changeModeFlag: false,
      channelTypeValue: "",
      channelTypeList: [],
      numberOption: [{ name: "1次兑换", id: 1 }],
      serveType: [{ name: "全病程服务", id: 1 }],
      expensesOption: [{ name: "付费服务", id: 1 }],
      equityType: [{ name: "全额兑换", id: 1 }],
      hospitalId: local.get("patientSchemeHospitalId"),
      pageStatus: "add",
      cardId: "",
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      baseForm: {
        cardChannelId: "",
        channelType: "",
        coopItem: "",
        splitAccountModel: "",
        cardNum: "",
        cashNum: 1,
        cooperationTypeArr: [],
        serviceEffectiveLimit: "",
        cashServiceType: 1,
        cashFeeType: 1,
        cashRights: 1,
        cardChannelCodePrefix: "",
        coopStartDate: "",
        coopEndDate: "",
        cashStartDate: "",
        cashEndDate: ""
      },
      basicRules: {
        cardChannelId: [
          { required: true, message: "请选择机构", trigger: "blur" }
        ],
        coopEndDate: [
          { required: true, message: "请选择合作期限日期", trigger: "blur" }
        ],
        splitAccountModel: [
          { required: true, message: "请选择分账模式", trigger: "change" }
        ],
        cardName: [
          { required: true, message: "请输入卡服务名称", trigger: "blur" }
        ],
        cashEndDate: [
          { required: true, message: "请选择兑换时限", trigger: "blur" }
        ],
        cardNum: [
          { required: true, message: "请输入卡密数量限额", trigger: "blur" }
        ],
        cashNum: [
          { required: true, message: "请选择兑换次数", trigger: "blur" }
        ],
        cashServiceType: [
          { required: true, message: "请选择服务类目", trigger: "blur" }
        ],
        serviceEffectiveLimit: [
          { trigger: "blur", message: "请输入服务有效时限", required: true }
        ],
        cashFeeType: [
          { required: true, message: "请选择资费类型", trigger: "change" }
        ],
        cashRights: [
          { required: true, message: "请选择权益", trigger: "change" }
        ],
        cardChannelCodePrefix: [
          { required: true, message: "请输入渠道码", trigger: "blur" },
          { min: 4, max: 4, message: "渠道码长度为4", trigger: "blur" }
        ]
      },
      splitAccountModelOption: [
        { label: "无分账", id: 1 },
        { label: "进账", id: 2 },
        { label: "出账", id: 3 }
      ]
    };
  },
  watch: {},
  computed: {},
  created() { 
    this.getChannelTypeList();
    if (this.$route.query.type == "view" || this.$route.query.type == "edite") {
      this.pageStatus = this.$route.query.type;
      this.cardId = this.$route.query.cardId;
      this.getDetail(this.$route.query.cardId);
    } 
  },
  mounted() {
    if(this.pageStatus == 'edite'){ 
      this.basicRules.cardChannelCodePrefix[1].max = 15
    }
  },
  methods: {
    changeSelectModel(val) { 
      if (!this.changeModeFlag && val) {
        this.changeModeFlag = true;
      } 
    },
    inputLimit(val) {
      this.baseForm.serviceEffectiveLimit = val.replace(/^0|[^0-9]/g, "");
      if (!this.changeLimtFlag && val) {
        this.changeLimtFlag = true;
        this.$refs.basicForm.clearValidate("serviceEffectiveLimit");
      }
      if (!val) {
        this.changeLimtFlag = false;
      }
    },
    checkKey(val) {
      this.baseForm.cardChannelCodePrefix = val.replace(/[^a-zA-Z]/g, "");
    },
    checkNum(val) {
      this.baseForm.cardNum = val.replace(/^0|[^0-9]/g, "");
    },
    async getChannelTypeList() {
      let res = await getChannelType();
      if (res.code == 0) {
        this.channelTypeList = res.data;
      }
    },
    getHospitalId(val, channelId) {
      if (val) {
        this.baseForm.cardChannelId = val;
        this.$refs.basicForm.clearValidate("cardChannelId");
      }
      this.baseForm.channelType = channelId;
    },
    resetBasicForm() {
      // this.$refs.basicForm.resetFields();
      this.baseForm.coopItem = "";
      this.baseForm.coopEndDate = "";
      this.baseForm.cashEndDate = "";
      this.baseForm.splitAccountModel = ""; 
      this.$nextTick(()=>{
        this.$refs.basicForm.clearValidate("splitAccountModel");
      }) 
      this.changeModeFlag = false; 
      this.changeLimtFlag = false
      this.baseForm.cardName = "";
      this.baseForm.cardNum = "";
      this.baseForm.serviceEffectiveLimit = "";
      if (
        this.pageStatus == "add" ||
        (this.pageStatus == "edite" && this.baseForm.cardCashState == 1)
      ) {
        this.baseForm.cashStartDate = "";
        this.baseForm.coopStartDate = "";
      }
      if (this.pageStatus != "edite") {
        this.baseForm.cardChannelCodePrefix = "";
        this.baseForm.cardChannelId = "";
        this.$refs.channelHospital.resettingVal();
        this.baseForm.channelType = "";
      }
    },
    backPage(){
      let commodityCon = local.get("cardPwdListCon");  
      this.$router.push({
        name: "/termPage/cardPwd",
        params: { condition: JSON.parse(commodityCon)}
      }); 
    },
    async getDetail(id) {
      let res = await cardDetails(id);
      if (res.code == 0) {
        this.baseForm = res.data;
        this.baseForm.cardChannelCodePrefix = res.data.cardChannelCode;
      }
    },
    async saveBasicForm() { 
      let valRes;
      this.$refs.basicForm.validate((val, el) => { 
        valRes = val;
      });
      if (!valRes) {
        return false;
      }
      if (!this.baseForm.cashStartDate) {
        this.$message.error("请选择合作期限开始日期！");
        return;
      }
      if (!this.baseForm.coopStartDate) {
        this.$message.error("请选择卡密兑换时限开始日期！");
        return;
      }
      if (
        new Date(this.baseForm.coopStartDate) >
        new Date(this.baseForm.coopEndDate)
      ) {
        this.$message.error("合作期限起始日期不可大于截止日期！");
        return;
      }
      if (
        new Date(this.baseForm.cashStartDate) >
        new Date(this.baseForm.cashEndDate)
      ) {
        this.$message.error("卡密兑换时限起始日期不可大于截止日期！");
        return;
      }

      let params = this.baseForm;
      // 修改
      if (this.cardId) {
        params.cardId = this.cardId;
        let res = await editeCard(params);
        if (res.code == 0) {
          this.$message.success("编辑成功！");
          setTimeout(() => {
            let commodityCon = local.get("cardPwdListCon");  
            this.$router.push({
              name: "/termPage/cardPwd",
              params: { condition: JSON.parse(commodityCon)}
            }); 
          }, 1000);
        }
      } else {
        // 新增
        let res = await addCard(params);
        if (res.code == 0) {
          this.$message.success("添加成功！");
          setTimeout(() => {
            this.$router.push({
              path: "/termPage/cardPwd"
            });
          }, 1000);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  background: #fff;
  .text {
    padding: 24px;
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    span:nth-child(2) {
      color: #333;
      flex: 1;
    }

    span:nth-child(1) {
      color: #999;
    }
  }
}

.content {
  background: #fff;
  margin: 20px;
  padding: 30px 8px;
  /deep/.el-form .el-form-item {
    margin-right: 24px;
    margin-bottom: 30px;
  }
  .box-item {
    padding: 0 16px;
    display: flex;
    span {
      flex: 1;
    }
  }
  /deep/.el-input {
    width: 360px;
  }
  .serviceTime {
    // position: relative;
    .title {
      font-size: 14px;
      color: #606266;
      margin: 0 11px;
    }
    .upTips {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      position: absolute;
      top: 100%;
      left: 90px;
    }
  }

  .serviceTime /deep/.el-form-item__error {
    margin-left: 90px;
  }

  .serviceTime /deep/.el-input {
    width: 268px;
  }
  /deep/.el-input-group__append {
    width: 55px;
    .el-input {
      width: 100%;
    }
  }
  .bottom-btn {
    margin-top: 80px;
    .el-button {
      width: 110px;
      height: 36px;
      line-height: 2px;
    }
  }
  .channel-code {
    display: flex;
    .el-input {
      width: 160px;
    }
    .el-icon-plus {
      margin: 0 16px;
    }
    align-items: center;
  }
  .self-date {
    width: 160px;
  }
  .separator {
    margin: 0 16px;
  }
}
</style>